import { EnumColor } from '@40seas/frontend/common/providers';
import { InsuranceStatus } from '@40seas/entities/insurance';

export const insuranceStatusColorMapping = {
    [InsuranceStatus.Pending]: 'default',
    [InsuranceStatus.Approved]: 'success',
    [InsuranceStatus.Declined]: 'error',
    [InsuranceStatus.OnHold]: 'warning',
    [InsuranceStatus.Canceled]: 'default',
} as { [key in InsuranceStatus]: EnumColor };
